import React from "react";
import "./client_profile.css";
import { FaArrowLeft, FaFileAlt, FaMoneyBill, FaFileInvoice } from "react-icons/fa";

export default function ClientProfile() {
  return (
    <div className="client-container">
      <header className="header">
        <button className="back-btn" onClick={() => window.history.back()}>
          <FaArrowLeft /> <span>Back to Company's</span>
        </button>
      </header>

      <div className="client-header">
        <div className="client-info">
          <h1 className="client-name">Sarah Company</h1>
          <p className="client-email">company1@example.com</p>
          <p className="client-company">Tech Startup Inc</p>
        </div>
        <span className="status-badge active">Active</span>
      </div>

      <div className="summary-cards">
        <div className="cards">
          <div className="card-icon">
            <FaFileAlt />
          </div>
          <div className="card-content">
            <p className="card-label">Total Documents</p>
            <p className="card-value">1</p>
          </div>
        </div>

        <div className="cards">
          <div className="card-icon">
            <FaFileInvoice />
          </div>
          <div className="card-content">
            <p className="card-label">Total Expenses</p>
            <p className="card-value">2</p>
          </div>
        </div>

        <div className="cards">
          <div className="card-icon">
            <FaMoneyBill />
          </div>
          <div className="card-content">
            <p className="card-label">Total Amount</p>
            <p className="card-value">$535.50</p>
          </div>
        </div>
      </div>

      <section className="section">
        <div className="section-header">
          <h2 className="section-title">Recent Documents</h2>
          <p className="section-subtitle">Documents uploaded by this company side</p>
        </div>

        <table className="table">
          <thead>
            <tr>
              <th>File Name</th>
              <th>Type</th>
              <th>Status</th>
              <th>Uploaded</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>invoice-jan-2024.pdf</td>
              <td>Invoice</td>
              <td>
                <span className="status-badge completed">Completed</span>
              </td>
              <td>20/01/2024</td>
              <td className="actions">⬇ Download</td>
            </tr>
          </tbody>
        </table>
      </section>

      <section className="section">
        <div className="section-header">
          <h2 className="section-title">Recent Expenses</h2>
          <p className="section-subtitle">Expenses tracked by this company</p>
        </div>

        <table className="table">
          <thead>
            <tr>
              <th>Description</th>
              <th>Category</th>
              <th>Amount</th>
              <th>Date</th>
              <th>Method</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Office supplies purchase</td>
              <td>Office Supplies</td>
              <td>$450.00 USD</td>
              <td>18/01/2024</td>
              <td>
                <span className="method-badge upload">Upload</span>
              </td>
            </tr>
            <tr>
              <td>Company lunch meeting</td>
              <td>Meals & Entertainment</td>
              <td>$85.50 USD</td>
              <td>22/01/2024</td>
              <td>
                <span className="method-badge voice">Voice</span>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
    </div>
  );
}
